import { atom } from 'recoil';
import sessionStorageEffect from '../effects/sessionStorageEffect';

// Backwards compatible key name with original cash out
const KEY = 'access_token';

export default atom({
  key: 'accessTokenAtom',
  default: null,
  effects: [
    sessionStorageEffect(KEY),
  ],
});
